import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ErrorService } from 'src/app/error.service';
import { Subscription } from 'rxjs';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {
  public username: string;
  public password: string;
  public disabled = false;
  public wrong = false;
  public error_msg: string;
  private error_subscription: Subscription;

  constructor(private auth: AuthService, private error_service: ErrorService) { }

  ngOnInit(): void {
    this.error_subscription = this.error_service.error$.subscribe((err) => {
      console.error('err: ', err);
      if (err) {
        this.error_msg = `Server disrupted. Please login again. err=${err.message}`;
      }
    });
  }

  public onSubmit($event: Event): void {
    this.disabled = true;
    $event.preventDefault();
    this.auth.login(this.username, this.password).subscribe(
      (res: boolean) => {
        if (res === true) {
          this.auth.onLoginSuccess();
        } else {
          this.wrong = true;
          setTimeout(() => {
            this.wrong = false;
            this.password = '';
            this.disabled = false;
          }, 1000);
        }
      },
      (err: any) => {
        this.error_msg = err.statusText;
        this.wrong = true;
        setTimeout(() => {
          this.wrong = false;
          this.password = '';
          this.disabled = false;
        }, 1000);
      },
    );
  }

  ngOnDestroy(): void {
    this.error_subscription.unsubscribe();
  }
}
